import React from 'react';
import { useTelegramHandoff } from '../../hooks/useTelegramHandoff';
import { useTheme, usePreset } from '../../lib/ThemeContext';
import { TelegramIcon } from '../TelegramIcon';

/**
 * "Open in Telegram" button shown under the greeting while the conversation is empty
 */
export const TelegramLink: React.FC = () => {
  const { telegramBotUrl, t } = useTheme();
  const openTelegram = useTelegramHandoff(telegramBotUrl);
  const preset = usePreset();
  const isNv = preset === 'nv';
  const isNevi = preset === 'nevi';

  if (!telegramBotUrl) return null;

  if (isNv || isNevi) {
    return (
      <a
        href={telegramBotUrl}
        onClick={openTelegram}
        target="_blank"
        rel="noopener noreferrer"
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: '8px',
          padding: '6px 8px 6px 16px',
          background: isNevi ? 'rgba(251, 251, 251, 0.05)' : '#FFFFFF',
          border: isNevi ? '1px solid rgba(251, 251, 251, 0.15)' : '1px solid rgba(46, 46, 46, 0.15)',
          borderRadius: isNevi ? '8px' : '100px',
          textDecoration: 'none',
          cursor: 'pointer',
          transition: 'opacity 0.15s ease',
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.opacity = '0.8';
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.opacity = '1';
        }}
      >
        <span
          style={{
            fontFamily: isNevi ? "'WC-Satoshi', system-ui, sans-serif" : "'WC-Involve', sans-serif",
            fontWeight: 500,
            fontSize: '14px',
            lineHeight: '20px',
            color: isNevi ? '#FBFBFB' : '#2E2E2E',
            whiteSpace: 'nowrap',
          }}
        >
          {t.chatIntro.openInTelegram}
        </span>
        <TelegramIcon fill={isNevi ? '#FBFBFB' : '#2E2E2E'} />
      </a>
    );
  }

  return (
    <a
      href={telegramBotUrl}
      onClick={openTelegram}
      target="_blank"
      rel="noopener noreferrer"
      className="wc-inline-flex wc-items-center wc-gap-2 wc-px-5 wc-py-2.5 wc-rounded-xl wc-text-sm wc-no-underline wc-transition-all wc-duration-200 hover:wc-scale-[1.03]"
      style={{
        background: 'rgba(41, 182, 246, 0.1)',
        color: '#29B6F6',
        border: '1px solid rgba(41, 182, 246, 0.2)',
      }}
    >
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
        <path
          d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm4.64 6.8c-.15 1.58-.8 5.42-1.13 7.19-.14.75-.42 1-.68 1.03-.58.05-1.02-.38-1.58-.75-.88-.58-1.38-.94-2.23-1.5-.99-.65-.35-1.01.22-1.59.15-.15 2.71-2.48 2.76-2.69a.2.2 0 00-.05-.18c-.06-.05-.14-.03-.21-.02-.09.02-1.49.95-4.22 2.79-.4.27-.76.41-1.08.4-.36-.01-1.04-.2-1.55-.37-.63-.2-1.12-.31-1.08-.66.02-.18.27-.36.74-.55 2.92-1.27 4.86-2.11 5.83-2.51 2.78-1.16 3.35-1.36 3.73-1.36.08 0 .27.02.39.12.1.08.13.19.14.27-.01.06.01.24 0 .38z"
          fill="#29B6F6"
        />
      </svg>
      {t.chatIntro.openInTelegram}
    </a>
  );
};
